import {
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  Renderer2,
  ViewEncapsulation
} from '@angular/core';
import { select, Store } from '@ngrx/store';
import { ActivatedRoute } from '@angular/router';
import { from, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ScriptInjectorService } from '../../core/services/script-injector.service';
import { environment } from '../../../environments/environment';
import * as fromRoot from '../../reducers';
import * as fromAuth from '../../auth/reducers';
import * as fromSettings from '../../settings/reducers';

@Component({
  selector: 'portal-messaging-page',
  templateUrl: 'messaging-page.component.html',
  styleUrls: ['./messaging-page.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MessagingPageComponent implements OnInit {
  public clinicMessagingLoaded$: Observable<boolean>;
  public conversationId$: Observable<string | null>;
  public selectedLanguage$: Observable<string | null>;
  public xSalveClinicToken$: Observable<string | null>;
  public messagesText$: Observable<{ [key: string]: string }>;

  constructor(
    private _store: Store<fromRoot.State>,
    private _route: ActivatedRoute,
    private _scriptInjector: ScriptInjectorService
  ) {}

  ngOnInit() {
    this.conversationId$ = from(
      this._route.paramMap.pipe(
        map((params) => {
          const id = params.get('conversationId');
          // != null catches null or undefined
          if (id != null) {
            return String(id);
          }
          return null;
        })
      )
    );
    this.selectedLanguage$ = this._store.pipe(select(fromAuth.getLanguageCode));
    this.xSalveClinicToken$ = this._store.pipe(select(fromAuth.getClinicId));
    this.messagesText$ = this._store.pipe(
      select(fromSettings.getSectionTranslations('Messages'))
    ) as any;
    this.clinicMessagingLoaded$ = from(
      this._scriptInjector
        .loadScript('salve-clinic-messaging', environment.messagingComponentUrl)
        .then(() => true)
        .catch(() => false)
    );
  }
}
